import { render, staticRenderFns } from "./PAPCreditVsDebitStore.vue?vue&type=template&id=36ac98c4&"
import script from "./PAPCreditVsDebitStore.vue?vue&type=script&lang=js&"
export * from "./PAPCreditVsDebitStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports